export interface AccountContext {
  accountId: string;
  accountNumber?: string | null;
  routingNumber?: string | null;
  accountStatus?: string | null;
  userId?: number | null;
  firstname?: string | null;
  lastname?: string | null;
  username?: string | null;
  artistName?: string | null;
}

export interface TransactionRow {
  id?: string | number | null;
  summary?: string | null;
  createdAt?: string | null;
  name?: string | null;
  routingNumber?: string | null;
  accountType?: string | null;
  type?: string | null;
  amount?: number | string | null;
  direction?: string | null;
}

export interface TransactionSummary {
  overview?: {
    netChange?: number | null;
    totalTransactions?: number | null;
    lastTransactionDate?: string | null;
    totalCredits?: number | null;
    totalDebits?: number | null;
  };
  creditsBreakdown?: {
    byType?: Record<string, number>;
  };
  debitsBreakdown?: {
    byType?: Record<string, number>;
  };
  insights?: {
    primaryIncomeSource?: string | null;
    primaryExpenseType?: string | null;
    spendingRatio?: number | null;
    netFlow?: string | null;
  };
}

export type NetFlow = 'positive' | 'negative' | 'neutral';

export function formatUsd(value: number): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
}

export function formatShortDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function sumBreakdown(byType?: Record<string, number>): number {
  return Object.values(byType || {}).reduce((sum, value) => sum + (typeof value === 'number' ? value : 0), 0);
}

export function normalizeNetFlow(value?: string | null): NetFlow {
  if (value === 'positive' || value === 'negative') return value;
  return 'neutral';
}

export function getTransactionAmount(tx: TransactionRow): number {
  return typeof tx.amount === 'number' ? tx.amount : 0;
}
